
// Version 1
// This function checks if the input (error from API) is an array. 
// If the error response is an array, it returns the first element.
// If the input is not an array, it assumes it's a string and returns it directly.

// const extractErrorMessage = (errorResponse) => {
//     if (Array.isArray(errorResponse)) {
//         return errorResponse[0]; // Return the first error if it's an array
//     }
//     return errorResponse; // Return the error directly if it's a string
// };


// Version 2
// errorUtils.js
// export const extractErrorMessage = (data) => {
//     const message = data?.error || data?.detail;
//     return Array.isArray(message) ? message[0] : message;
// };

// Version 3
export const extractErrorMessage = (data) => {
    
    // Check for generic error or detail fields first
    const genericMessage = data?.error || data?.detail;
    if (genericMessage) {
      return Array.isArray(genericMessage) ? genericMessage[0] : genericMessage;
    }

    // Handle field-specific errors, where the error is not prefixed with `error` or `detail`
    // Return the first error message from the first key
    const keys = Object.keys(data);
    // for (const key of keys) {
    //     const fieldErrors = data[key];
    //     if (Array.isArray(fieldErrors) && fieldErrors.length > 0) {
    //     return fieldErrors[0];
    //     }
    // }
    for (const key of keys) {
        const fieldErrors = data[key];
        if (Array.isArray(fieldErrors) && fieldErrors.length > 0) {
        return `${key}: ${fieldErrors[0]}`;
        }
    }

    // Fallback to a generic error message
    // return "An unknown error occurred.";
};